module.exports = __webpack_public_path__ + "img/ms.5042e90f.svg";